import { CALL_MODE } from '../constants/constants';
import { MESSAGE_CODE } from '../constants/Notifications';
import { SingletonCallOutData } from '../Singletons/SingletonCallData';
import { SingletonSharedData } from '../Singletons/SingletonSharedData';
let sharedData = new SingletonSharedData();
let sharedCallOutData = new SingletonCallOutData();
const senderType = 2;
let timeStampSession = '';

export function messageLogin(timeStamp) {
    try {
        timeStampSession = timeStamp;
    } catch (error) {
        console.warn(error);
    }
    let isRemote = 1;
    let myStorage = window.localStorage;
    let lastAgentTimeSpam = myStorage.getItem('AgentTimeSpam');

    return {
        action: 'login',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        ext: sharedData.getParameters().Extension,
        computer: sharedData.getParameters().ClientComp,
        Timestamp: timeStamp,
        Sender: senderType,
        remote: isRemote,
        LastNotReadyID: sharedData.getParameters().LastNotREADY,
        Ip: sharedData.getIPAddress(),
        LastAgentTimeSpam: lastAgentTimeSpam,
        DialingMode: sharedData.getUserData().DialingMode
    };
}

export function messageLogOut(timeStamp) {
    const obj = {
        action: 'Logout',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Timestamp: timeStamp
    };
    return JSON.stringify(obj);
}

export function messageKeepAlive(username = null, timeSpam = null) {
    return {
        keepAlive: 1,
        action: 'KeepAlive',
        Sender: senderType,
        username: username,
        timeSpam: timeSpam
    };
}

export function messageNoAvailable(userName, userID, notReadyID, conversationID,timeInPreview) {
    const obj = {
        action: 'notReady',
        username: userName,
        userID: userID,
        notReadyId: notReadyID,
        conversationID: conversationID != null ? conversationID : undefined,
        Sender: senderType,
        TimePreview: timeInPreview
    };
    return JSON.stringify(obj);
}

export function messageAgentRedy() {
    const obj = {
        action: 'ready',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Sender: senderType
    };
    return JSON.stringify(obj);
}

export function messageFirstCall(username, userID) {
    return {
        action: 'firstCall',
        username: username,
        userID: userID,
        Sender: senderType
    };
}

export function messageRetryFirstCall(username, userID) {
    const obj = {
        action: 'reconnect',
        username: username,
        userID: userID,
        Sender: senderType
    };
    return JSON.stringify(obj);
}

export function messagePassToReady(password, supervisorPassword, requieredSupervisorPass) {
    const obj = {
        nombre: sharedData.getUserData().Login,
        password: password,
        supervisorPassword: supervisorPassword,
        supervisorPasswordRequired: requieredSupervisorPass,
        ipAddress: sharedData.getParameters().ClientComp,
        Sender: senderType
    };
    return obj;
}

export function messageToSupervisor(message, admin) {
    const obj = {
        action: 'chatMessageAdmin',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        message: message,
        admin: admin,
        Sender: senderType
    };
    return JSON.stringify(obj);
}

export function messageNotifyAlreadyWrapUp() {
    const obj = {
        action: 'WrapUp',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID
    };
    return JSON.stringify(obj);
}

export function messageChangeStateHelper() {
    const obj = {
        action: 'ChangeState',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID
    };
    return JSON.stringify(obj);
}

export function messageStartStopRecording(isStop, callOutId=0) {
    const obj = {
        action: 'StartStopRecording',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        isStop: isStop,
        callOutId: callOutId
    };
    return JSON.stringify(obj);
}



export function messageApiRequest(subaction, json, expectsResponse = false, callOutId=0) {
    return {
        action: 'Api',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Subaction: subaction,
        Json: JSON.stringify(json),
        ExpectsReponse: expectsResponse,
        callOutId: callOutId
    };
}

export function messageApiReprogram(subaction, json, expectsResponse = false) {
    return {
        action: 'Api',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Subaction: subaction,
        Json: JSON.stringify(json),
        ExpectsReponse: expectsResponse
    };
}

export function messageHangUp(subaction,callOutId,maxTime) {
    return {
        action: 'HangUp',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Subaction: subaction,
        callOutId: callOutId,
        calloutMaxTime:maxTime
    };
}
export function messageTransferCall(data) {
    return {
        action: 'TransferCall',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        acdID: data.acdID,
        callKey: data.callKey,
        datos: data.array,
        typeTransfer: data.typeTransfer,
        camId: data.camId,
        sPhone: data.sPhone,
        dnis: data.dnis,
        extId: data.extId
    };
}
export function messageAssistedTransferCall(action,data) {
    const obj = {
        action,
        username: sharedData.getUserData().Login,
        reference: data.reference,
        phoneNumber: data.sPhone,
        callId: data.callId,
        typeTransfer: data.typeTransfer !== undefined ? data.typeTransfer : '-1',
        ...(action === "TransferPreviewCall" && {subaction : 'PreviewCallTransfer'}),
        ...(data.agentDest && {agentDest : data.agentDest})
    };
    return JSON.stringify(obj);
}

export function updateInfoCall(callKey,camId, dataCall, callOutId) {
    const obj = {
        action: 'UpdateDataCall',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Data: dataCall,
        callKey: callKey,
        camID: camId,
        CallOutId: callOutId
    };
    return JSON.stringify(obj);
}

export function manualCall(data) {
    const obj = {
        action: 'manualCall',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        CamId: data.CamId,
        CallKey: data.CallKey,
        Phone: data.Phone,
        Data: data.Data,
        ExistsCallout: data.ExistsCallout,
        CallMode: data.CallMode,
        integration: data.integration,
        Odbc: data.Odbc,
        Ani: data.ani
    };
    return JSON.stringify(obj);
}

export function messageOngoingCallIvr(id) {
    const obj = {
        action: 'OngoingCallIvr',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        id: id
    };
    return JSON.stringify(obj);
}

export function sendDisposition(data) {
    const obj = {
        action: 'endResponseMedia',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Timestamp: timeStampSession,
        MediaType: data.type,
        DispositionID: data.disposition,
        SubDispositionID: data.subDisposition,
        ConversationId: data.conversationId,
        MessageId: data.messageId ? data.messageId : 0,
        TWrapUp: data.wrapUp,
        AcdId: data.acdId,
        ExitWrapUpDisposition: data.closeModal,
        CampType: data.camptype != null ? data.camptype : 0
    };
    return JSON.stringify(obj);
}

export function RequestedLogout() {
    return {
        action: 'logout',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        conversationID: sharedData.getCurrentState() !== "DialogWhatsApp" || !sharedData.getSelectedConversationId() ? 0 : sharedData.selectedConversationId
    }
}

export const Reconnected = () => {
    return {
        action: 'Reconnected',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID
    };
};

export const changeState = (data) => {
	const obj = {
		action: 'WhatsAppDialog',
		username: sharedData.getUserData().Login,
		userID: sharedData.getUserData().User_id,
		Timestamp: timeStampSession,
		ConversationId: data.ConversationId,
		Tel: data.Tel,
		CamId: data.CamiId,
		CamType: data.CamType
	};
	return JSON.stringify(obj);
}

export function triggerNotifications(SDK, statusCode, type, from, message) {
    if(from === 'SDK'){
        message = statusCode.message;
        statusCode = statusCode.code
    } else {
        type = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
        type = (type === 'Alert') ? 'Warn' : type;
    }
    const updateNotification = {
        statusCode: statusCode,
        message: message,
        type: type,
        from: from
    };
    return SDK.notifications.notificationsManager(updateNotification);
}

export function requestPhoneNumber(campID, phoneNumber, data1, status, callKey) {
    return {
        UserID: sharedData.getParameters().UserID,
        CampID: campID,
        Ext: sharedData.getParameters().Extension,
        PhoneNumber: phoneNumber,
        Name: data1,
        CallOutChange: 0,
        Status: status,
        CallKey: callKey,
        CallMode: CALL_MODE.MANUAL_CALL
    }
}

export function setNotReady(notReadyID) {
    return {
        action: "notReady",
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        notReadyId: notReadyID,
        Sender: 2,
        TimePreview: 0,
    }
}

export function assistedCallMode(camID, callKey, phoneNumber, data1) {
    return {
        action: "manualCall",
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        CamId: camID,
        CallKey: callKey,
        Phone: phoneNumber,
        Data: data1 || "",
        ExistsCallout: 0,
        CallMode: CALL_MODE.ASSISTED_CALL,
        integration: false
    }
}

export function saveDispositionToSvr(disposition, subdisposition, exitAssistedMode) {
    return {
        CallId: Math.abs(sharedCallOutData.getCallOutDataFromCall().callID),
        DispositionId: disposition > 0 ? disposition : 0,
        Origin: '',
        CallKey: sharedCallOutData.getCallOutDataFromCall().callKey,        
        CallOutId: sharedCallOutData.getCallOutDataFromCall().callOutID,
        SubId: subdisposition > 0 ? subdisposition : 0,
        CallType: sharedCallOutData.getCallOutDataFromCall().callType,
        IsExitAssisted: exitAssistedMode,
        IsExitPreview: false
    }
}

export function getDispositionList(callOutID, campID, typeCall, userID) {
    return {
        CallOutId: sharedCallOutData.getCallOutDataFromCall().callOutID || callOutID,
        Id: sharedCallOutData.getCallOutDataFromCall().campId || campID,
        Type: typeCall === 2 ? 1 : 0,
        UserId: userID,
        CamId: sharedCallOutData.getCallOutDataFromCall().campId || campID,
    }
}